/**
 * Helper function to generate proper ARIA attributes for text inputs
 */
export function textInputProps({
  sharedTextInputProps,
  invalid,
  invalidId,
  warn,
  warnId,
}: {
  sharedTextInputProps: any;
  invalid?: boolean;
  invalidId?: string;
  warn?: boolean;
  warnId?: string;
}) {
  const textInputProps: any = {
    ...sharedTextInputProps,
  };

  if (invalid) {
    textInputProps['aria-invalid'] = true;
    textInputProps['aria-describedby'] = invalidId;
  } else if (warn) {
    textInputProps['aria-describedby'] = warnId;
  }

  return textInputProps;
}
